/**
 * Formata um valor de CPF ou CNPJ.
 *
 * - CPF: até 11 dígitos numéricos, máscara 000.000.000-00
 * - CNPJ numérico: 14 dígitos numéricos, máscara 00.000.000/0000-00
 * - CNPJ alfanumérico: 12 caracteres alfanuméricos + 2 dígitos numéricos,
 *   máscara AA.AAA.AAA/AAAA-DV
 */
export const formatCpfCnpj = (value) => {
  if (!value) return "";

  const cleaned = String(value)
    .replace(/[^a-zA-Z0-9]/g, "")
    .toUpperCase();

  // Detecta CPF: apenas números e até 11 dígitos
  const isNumeric = /^\d*$/.test(cleaned);
  if (isNumeric && cleaned.length <= 11) {
    return cleaned
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }

  // CNPJ numérico tradicional: 14 dígitos numéricos
  if (isNumeric && cleaned.length <= 14) {
    return cleaned
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
  }

  // CNPJ alfanumérico: base de 12 caracteres alfanuméricos + 2 dígitos verificadores
  const base = cleaned.slice(0, 12).replace(/[^A-Z0-9]/g, "");
  const dv = cleaned.slice(12, 14).replace(/[^0-9]/g, "");

  let formatted = base;
  if (base.length > 2) {
    formatted = base.slice(0, 2) + "." + base.slice(2);
  }
  if (base.length > 5) {
    formatted = formatted.slice(0, 6) + "." + formatted.slice(6);
  }
  if (base.length > 8) {
    formatted = formatted.slice(0, 10) + "/" + formatted.slice(10);
  }
  if (dv.length > 0) {
    formatted = formatted + "-" + dv;
  }

  return formatted;
};
